import {
  AfterContentChecked,
  Component,
  OnInit,
  ViewChild,
  inject
} from '@angular/core';
import {
  ApiServiceService,
  LoggingService,
  NotificationService
} from '@oneeducation/app-core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { USER_ENDPOINT } from '@shared/properties';
import { userModel } from '@usermanagement/.';
import { AccessibilityService } from '@shared/services';

@Component({
  selector: 'app-view-users',
  templateUrl: './view-users.component.html',
  standalone: false
})
export class ViewUsersComponent implements OnInit, AfterContentChecked {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly notificationService = inject(NotificationService);
  private readonly loggingService = inject(LoggingService);
  private readonly apiservice = inject(ApiServiceService);
  private readonly accessibilityService = inject(AccessibilityService);

  public schoolId;
  public user: userModel[];
  public schoolName;
  public noRecordMsgFlag;
  @ViewChild('schoolUsers') schoolUsers: any;

  constructor() {
    const config = this.config;

    this.schoolId = config.data.schoolData.schoolId;
  }

  ngOnInit(): void {
    this.GetSchoolUserDetails();
  }

  GetSchoolUserDetails() {
    this.apiservice
      .getAll<
        userModel[]
      >(USER_ENDPOINT.GetUsersBySchool.replace('{schoolId}', this.schoolId), '')
      .subscribe({
        next: (x: any) => {
          this.noRecordMsgFlag = false;
          this.user = x.users;
          this.user.forEach((att) => {
            const filteredschool = att.schools.find(
              (y) => y.schoolId === this.schoolId
            );

            if (att.firstName === null || att.firstName === '') {
              att.status = 'Active';
            } else if (!filteredschool.active) {
              att.status = 'Inactive';
            } else {
              att.status = 'Registered ';
            }
            att.active = filteredschool.revokeAccess
              ? 'No'
              : !filteredschool.active
                ? 'No'
                : 'Yes';
          });
        },
        error: (x: any) => {
          this.noRecordMsgFlag = true;
          if (x.error !== null && x.error !== '' && x.status !== 404) {
            this.notificationService.showError(x.error.message);
            this.loggingService?.logError(x);
          }
        }
      });
  }

  ngAfterContentChecked(): void {
    this.setDialogBoxAriaAttributes();
    this.setTabindexInScrollableRegionForDialogBox();
  }

  // Ensures every ARIA dialog and alertdialog node has an accessible name
  private setDialogBoxAriaAttributes() {
    if (this.schoolUsers) {
      const title = 'School Users';
      this.accessibilityService.setDynamicDialogBoxAriaAttributes(
        this.schoolUsers,
        title
      );
    }
  }

  // Ensure elements that have scrollable content are accessible by keyboard
  private setTabindexInScrollableRegionForDialogBox() {
    if (this.schoolUsers) {
      this.accessibilityService.setTabindexInScrollableRegionForDialogBox(
        this.schoolUsers
      );
    }
  }
}
